var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#8EDAEA",
    cx: 18,
    cy: 18,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8EDAEA",
    fillRule: "nonzero",
    d: "M25 15.3412604L23.59 14 18 19.3174792 12.41 14 11 15.3412604l5.59 5.3174792L18 22l1.41-1.3412604z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedChevronDown);
export default __webpack_public_path__ + "static/media/rounded-chevron-down.952944c074a7c3fc246c214809908bd7.svg";
export { ForwardRef as ReactComponent };